module.exports = __webpack_public_path__ + "img/password.92a4e6d4.svg";